import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Body, Drawer } from 'components/Shell/Shell'
import { Modal } from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import Toolbar from 'components/Table/Toolbar'
import DataRequestBlock from './DataRequestBlock'
import ReportsList from 'components/MyWorkQueue/ReportsList'
import AmendmentLauncher from 'components/MyRecords/AmendmentLauncher'
import { history } from '../../store'
import Markdown from 'components/Markdown/Markdown'
import {
  GET_DATA_REQUEST_WIZARDS,
  GET_MY_DATA_REQUESTS,
  GET_APP_SETTING_BY_NAME,
  GET_RESOLVED_APP_SETTING_BY_NAME,
  GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM,
  DELETE_DATA_REQUEST_FILING
} from 'requests'
import ManageDrawer from './ManageDrawer'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import ConnectedCheckout from 'components/Checkout/Checkout'
import { setCartQuantity, setErrorToast, setSuccessToast } from '../../actions'
import { Spinner } from 'components/Loaders/Loaders'
import { calculateReceiptItemsTotal, calculateReceiptItemContainersTotal } from 'utilities'
import './DataRequests.scss'
import { SUBROUTES } from '../../App'

const SHOPPING_CART = process.env.SHOPPING_CART

class DataRequests extends React.Component {
  state = {
    filter: '',
    activeDrawerProps: null,
    drawerTitleCache: '',
    drawerSubtitleCache: '',
    drawerType: null,
    drawerOpen: false,
    modalOpen: false,
    checkoutOpen: false,
    requests: [],
    title: 'Data Requests',
    description: '',
    buttonLabel: '',
  }
  componentDidMount = () => {
    this.getDataRequests()
    this.getAppSettings()
    this.getAppSettingLabels()
    const dataRequestRoute = SUBROUTES && SUBROUTES.find((s) => s.SourceTypeId === 869)
    if (dataRequestRoute) {
      this.setState({ title: dataRequestRoute.label })
    }
  }
  getDataRequests = (updateManagementDrawer) => {
    new Promise((resolve, reject) => {
      GET_MY_DATA_REQUESTS(
        (requests) => {
          resolve(this.setState({ requests: requests }))
          if (updateManagementDrawer) {
            const activeRequest = requests.find(
              (x) => x.DataRequestFilingId === this.state.activeDrawerProps.id
            )
            if (activeRequest) {
              this.startManagementDrawer(activeRequest, true)
            }
          }
        },
        (err) => {
          console.error(err)
          reject(err)
        }
      )
    })
  }

  getAppSettings = () => {
    GET_APP_SETTING_BY_NAME('DataRequestHideHelp', ({ VALUE }) => {
      this.setState({ dataRequestHideHelp: !!VALUE && VALUE === 'true' })
    })
    GET_APP_SETTING_BY_NAME('DataRequestBody', ({ VALUE }) => {
      this.setState({ dataRequestBody: VALUE })
    })
  }
  getAppSettingLabels = () => {
    GET_APP_SETTING_BY_NAME('DATA_REQUEST_DESCRIPTION', ({ VALUE }) => {
      this.setState((state) => ({
        ...state,
        description: VALUE ? VALUE : 'App Setting: "DATA_REQUEST_DESCRIPTION" not set.',
      }))
    })
    GET_APP_SETTING_BY_NAME('DATA_REQUEST_LABEL', ({ VALUE }) => {
      this.setState((state) => ({
        ...state,
        buttonLabel: VALUE ? VALUE : '',
      }))
    })
  }
  closeDrawer = () => this.setState({ activeDrawerProps: null })
  clearFilter = () => this.setState({ filter: '' })
  startManagementDrawer = (dr, keepDrawerOpen) => {
    this.setState((state) =>
      state.drawerType === 'manage' &&
      state.activeDrawerProps &&
      state.activeDrawerProps.id === dr.DataRequestFilingId &&
      state.drawerOpen &&
      keepDrawerOpen !== true
        ? { drawerOpen: false }
        : {
            activeDrawerProps: {
              id: dr.DataRequestFilingId,
              num: dr.FilingNum,
              formDefinitionId: dr.FormDefinitionId,
              nickname: dr.Nickname,
              statusId: dr.STATUS_ID,
              canEdit: dr.CanEdit,
              canPause: dr.PauseEnabled,
              canUnpause: dr.CanUnpause,
              canEditPayment: dr.PauseEnabled,
              activeSubscription: dr.activeSubscription,
              searchUrl: dr.searchUrl,
              canCancel : dr.CanCancel,
            },
            drawerTitleCache: dr.Name,
            drawerNicknameCache: dr.NAME_OVERRIDE,
            drawerSubtitleCache: dr.DataRequestStatusType,
            drawerType: 'manage',
            drawerOpen: true,
          }
    )
  }
  startDownloadsDrawer = (dr) =>
    this.setState((state) =>
      state.drawerType === 'downloads' &&
      state.activeDrawerProps &&
      state.activeDrawerProps.id === dr.DataRequestFilingId &&
      state.drawerOpen
        ? { drawerOpen: false }
        : {
            activeDrawerProps: {
              id: dr.DataRequestFilingId,
              formDefinitionId: dr.FormDefinitionId,
              nickname: dr.nickname,
              statusId: dr.STATUS_ID,
              canEdit: dr.CanEdit,
              canPause: dr.PauseEnabled,
              canUnpause: dr.CanUnpause,
              canEditPayment: dr.PauseEnabled,
            },
            drawerTitleCache: dr.Name,
            drawerNicknameCache: dr.Nickname,
            drawerSubtitleCache: dr.DataRequestStatusType,
            drawerType: 'downloads',
            drawerOpen: true,
          }
    )
  getReceiptItems = (amendmentNum) => {
    return new Promise((resolve, reject) => {
      GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM(
        amendmentNum,
        'datarequests',
        false,
        (receiptItems) => {
          resolve(receiptItems)
        },
        (error) => {
          reject(error)
          this.props.setErrorToast(error.message)          
        }
      )
    })
  }
  redirectToSearch = (searchUrl) => {
    this.props.history.push(searchUrl)
  }
  startCheckout = (dr) => {    
    let dataRequestItemId = dr.FilingNum
    this.getReceiptItems(dataRequestItemId)
      .then(({ RECEIPT_ITEM_WEB_LIST, RECEIPT_ITEM_CONTAINER_WEB_LIST, REF_NUM }) => {
        const total = RECEIPT_ITEM_CONTAINER_WEB_LIST
          ? calculateReceiptItemContainersTotal(RECEIPT_ITEM_CONTAINER_WEB_LIST)
          : calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)

        this.setState(
          {
            checkoutOpen: total > 0 ? true : false,
            checkoutDetails: {
              amendmentNum: dr.DataRequestFilingId,
              receiptItems: RECEIPT_ITEM_WEB_LIST,
              receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
              refNum: REF_NUM,
            },
          },
          () => {
            if (SHOPPING_CART) {
              setCartQuantity(RECEIPT_ITEM_CONTAINER_WEB_LIST.filter((x) => !x.IS_FREE).length)
              this.getDataRequests(true)
            }
            if (total <= 0) {
              this.openReceipt()
            }
          }
        )
      })
      .catch((error) => {
        this.getDataRequests(false)
      })
  }
  deleteFiling = (dr) => {
    DELETE_DATA_REQUEST_FILING(
      dr.DataRequestFilingId,
      (success) => {
        this.getDataRequests(true);
        this.props.setSuccessToast(success);                      
      },
      (error) => {
        this.getDataRequests(true);      
        this.props.setErrorToast(error.message);        
      }
    );       
  }
  closeCheckout = () => {
    this.getDataRequests(true)
    this.setState({ checkoutOpen: false })
  }
  cancelCheckout = () => {
    this.slider.closeSlider(() => {
      this.closeCheckout()
    })
  }
  openReceipt = (refNum) => {
    if (this.slider) {
      this.slider.closeSlider(() => {
        this.props.history.push(`/receipt?ref=${refNum || this.state.checkoutDetails.refNum}`)
      })
    } else {
      this.props.history.push(`/receipt?ref=${refNum || this.state.checkoutDetails.refNum}`)
    }
  }
  toggleSelectorModal = () => this.setState((state) => ({ modalOpen: !state.modalOpen }))
  getAvailableAmendments = () =>
    new Promise((resolve, reject) => {
      GET_DATA_REQUEST_WIZARDS(
        (amendments) => {
          resolve(amendments)
        },
        (err) => {
          console.error(err)
          reject(err)
        }
      )
    })
  openAmendment = (formDefinitionId) => {
    history.push(`/forms/new/${formDefinitionId}`)
  }
  toggleHelpModal = () => {
    this.setState((state) =>
      state.drawerType === 'help' && state.drawerOpen
        ? {
            drawerOpen: false,
          }
        : {
            drawerType: 'help',
            drawerTitleCache: `${this.state.buttonLabel} Help`,
            drawerSubtitleCache: '',
            activeDrawerProps: {},
            drawerOpen: true,
          }
    )
  }
  setNicknameById = (dataRequestId, nickname) => {
    this.setState((state) => {
      const index = state.requests.findIndex((x) => x.DataRequestFilingId === dataRequestId)
      return {
        drawerNicknameCache: nickname ? nickname : state.drawerTitleCache,
        requests: [
          ...state.requests.slice(0, index),
          { ...state.requests[index], NAME_OVERRIDE: nickname },
          ...state.requests.slice(index + 1),
        ],
      }
    })
  }
  handleSidebarDismissed = () => {
    switch (this.state.drawerType) {
      case 'help':
        this.toggleHelpModal()
        break
      case 'manage':
      case 'downloads':
      default:
        this.setState({ drawerOpen: false })
    }
  }
  render() {
    return (
      <Body className="data-requests" showDrawer={!!this.state.drawerOpen}>
        <Toolbar
          title={
            <React.Fragment>
              {this.state.title}
              <button
                className="help-button"
                aria-label="View Help"
                onClick={this.toggleHelpModal}
                hidden={this.state.dataRequestHideHelp}
              >
                ?
              </button>
            </React.Fragment>
          }
          underToolbar={
            <div>
              {this.state.dataRequestBody ? (
                <div
                  className="help-body"
                  dangerouslySetInnerHTML={{ __html: this.state.dataRequestBody }}
                ></div>
              ) : null}
              {this.state.description ? (
                <p className="description">{this.state.description}</p>
              ) : null}
            </div>
          }
          className="center-container"
          searchable={false}
          rightAlignChildren={
            <button className="btn btn-primary btn-raised" onClick={this.toggleSelectorModal}>
              {`+ New ${this.state.buttonLabel}`}
            </button>
          }
        />
        <ul className="data-request-blocks">
          {(this.state.requests || []).map((dr) => (
            <DataRequestBlock
              {...dr}              
              isActive={
                this.state.activeDrawerProps &&
                this.state.activeDrawerProps.id === dr.DataRequestFilingId &&
                this.state.drawerOpen
              }
              onManageClicked={() => this.startManagementDrawer(dr)}
              onDownloadsClicked={() => this.startDownloadsDrawer(dr)}
              onAddToCartClicked={() => this.startCheckout(dr)}
              OnDeleteClicked={() => this.deleteFiling(dr)}
              checkoutOpen={this.state.checkoutOpen}
              key={dr.DataRequestFilingId}
              useSearchIcon={dr.searchUrl}
              onSearchClicked={dr.searchUrl ? () => this.redirectToSearch(dr.searchUrl) : null}
            />
          ))}
        </ul>
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            modalSize="small"
            title={`Select a ${this.state.buttonLabel}`}
            closeButton
            closeModal={this.toggleSelectorModal}
          >
            <AmendmentLauncher
              getAvailableAmendments={this.getAvailableAmendments}
              openAmendment={this.openAmendment}
            />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.checkoutOpen}>
          <SlidingPanel
            closeOnShadeClick={false}
            closeSlider={this.closeCheckout}
            ref={(ref) => {
              this.slider = ref
            }}
          >
            <ConnectedCheckout
              cancelCheckout={this.cancelCheckout}
              closeModal={this.closeCheckout}
              redirectToReceipt={this.openReceipt}
              amendmentNum={this.state.checkoutOpen && this.state.checkoutDetails.amendmentNum}
              refNum={this.state.checkoutOpen && this.state.checkoutDetails.refNum}
              formDefinitionId={
                this.state.checkoutOpen && this.state.checkoutDetails.formDefinitionId
              }
              category="data-request"
              receiptItems={this.state.checkoutOpen && this.state.checkoutDetails.receiptItems}
              receiptItemContainers={
                this.state.checkoutOpen && this.state.checkoutDetails.receiptItemContainers
              }
              onReceiptItemContainerRemoved={() => this.getDataRequests(true)}
            />
          </SlidingPanel>
        </Portal>
        <Drawer
          show={this.state.drawerOpen}
          showCloseButton={true}
          title={this.state.drawerNicknameCache || this.state.drawerTitleCache}
          subtitle={this.state.drawerSubtitleCache}
          onSidebarDismiss={this.handleSidebarDismissed}
          ariaCloseLabel={this.state.drawerType === 'help' ? 'Close Help' : 'Close'}
        >
          {this.state.drawerType === 'manage' && (
            <ManageDrawer
              formDefinitionId={this.state.activeDrawerProps.formDefinitionId}
              dataRequestId={this.state.activeDrawerProps.id}
              dataRequestNum={this.state.activeDrawerProps.num}
              frequencyTypeId={this.state.activeDrawerProps.frequencyTypeId}
              statusId={this.state.activeDrawerProps.statusId}
              canEdit={this.state.activeDrawerProps.canEdit}
              canEditPayment={this.state.activeDrawerProps.canEditPayment}
              canPause={this.state.activeDrawerProps.canPause}
              canUnpause={this.state.activeDrawerProps.canUnpause}
              canSearch={this.state.activeDrawerProps.searchUrl}
              canCancel={this.state.activeDrawerProps.canCancel}
              nickname={this.state.activeDrawerProps.nickname}
              onNicknameChange={(nickname) =>
                this.setNicknameById(this.state.activeDrawerProps.id, nickname)
              }
              onCanceled={() => this.getDataRequests(true)}
              onPause={() => this.getDataRequests(true)}
              onUnpause={() => this.getDataRequests(true)}
              onSearch={() => this.redirectToSearch(this.state.activeDrawerProps.searchUrl)}
            />
          )}
          {this.state.drawerType === 'downloads' && (
            <ReportsList
              amendmentNum={this.state.activeDrawerProps.id}
              formDefinitionId={this.state.activeDrawerProps.formDefinitionId}
            />
          )}
          {this.state.drawerType === 'help' && <Help />}
        </Drawer>
      </Body>
    )
  }
}

export default connect(null, { setErrorToast, setSuccessToast })(DataRequests)

let helpCache = null

const Help = () => {
  const [help, setHelp] = useState(helpCache)
  const [loading, setLoading] = useState(!helpCache)

  useEffect(() => {
    if (!help) {
      setLoading(true)
      GET_RESOLVED_APP_SETTING_BY_NAME('HELP_ICON_TEXT_DATA_REQUEST', ({ VALUE }) => {
        helpCache = VALUE
        setHelp(VALUE)
        setLoading(false)
      })
    }
  }, [])

  return loading ? (
    <div className="reports-spinner animated fadeIn">
      <Spinner size="medium" themeColor="secondary" />
    </div>
  ) : (
    <Markdown className="markdown" source={help || ''} />
  )
}
